import * as NS from './namespace';

const getters: NS.IAuthGetters = {
    getActiveFormRequest(state: NS.IAuthState): boolean {
        return state.activeFormRequest;
    },
    getFailedFormRequest(state: NS.IAuthState): boolean {
        return state.failedFormRequest;
    },
    isAuthenticated(state: NS.IAuthState): boolean {
        return (
               state.token !== undefined 
            && state.token !== '' 
            && state.user !== undefined
            );
    },
    isAdmin(state: NS.IAuthState): boolean {
        return state.user !== undefined ? state.user.isAdmin : false;
    },
    getUserLogin(state: NS.IAuthState): string | undefined {
        return state.user !== undefined ? state.user.login : undefined;
    },
    getUserId(state: NS.IAuthState): string | undefined {
        return state.user !== undefined ? state.user.userId : undefined;
    },
}

/**
 * Реализация геттеров модуля аутентицикации
 */
export default getters;